var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreateAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0285 22.4875C16.5671 22.4875 21.057 20.2425 21.057 17.4732C21.057 14.7039 16.5671 12.459 11.0285 12.459C5.48992 12.459 1 14.7039 1 17.4732C1 20.2425 5.48992 22.4875 11.0285 22.4875Z",
    fill: "#FDAB29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0286 22.1286C16.3694 22.1286 20.6989 20.044 20.6989 17.4725C20.6989 14.901 16.3694 12.8164 11.0286 12.8164C5.68778 12.8164 1.35822 14.901 1.35822 17.4725C1.35822 20.044 5.68778 22.1286 11.0286 22.1286Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0289 15.3265C14.9851 15.3265 18.1921 12.1194 18.1921 8.16323C18.1921 4.20709 14.9851 1 11.0289 1C7.07278 1 3.86569 4.20709 3.86569 8.16323C3.86569 12.1194 7.07278 15.3265 11.0289 15.3265Z",
    fill: "#FDAB29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0289 14.9676C14.7872 14.9676 17.8339 11.9208 17.8339 8.16249C17.8339 4.40415 14.7872 1.35742 11.0289 1.35742C7.27055 1.35742 4.22382 4.40415 4.22382 8.16249C4.22382 11.9208 7.27055 14.9676 11.0289 14.9676Z",
    stroke: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2143 18.15H14.25V16.25H17.2143H17.4643V16V13.25H19.5357V16V16.25H19.7857H22.75V18.15H19.7857H19.5357V18.4V21.75H17.4643V18.4V18.15H17.2143Z",
    fill: "#FFAD45",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateAccount);
export default __webpack_public_path__ + "static/media/create-account.1e41e4eadd971d34ff15c77524d49eb4.svg";
export { ForwardRef as ReactComponent };